import clsx from 'clsx';
import { useState } from 'react';
import { KTIcon } from '../../../../helpers';
import { Dropdown1 } from '../../../../partials';
import { useLayout } from '../../../core';

const ToolbarClassic = () => {
  const { config } = useLayout();
  const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false);
  const daterangepickerButtonClass = config.app?.toolbar?.fixed?.desktop
    ? 'btn-light'
    : 'bg-body btn-color-gray-700 btn-active-color-primary';

  return (
    <div className="d-flex align-items-center gap-2 gap-lg-3">
      {!!config.app?.toolbar?.filterButton && (
        <div className="m-0">
          <a
            className={clsx('btn btn-sm btn-flex fw-bold', daterangepickerButtonClass)}
            data-kt-menu-placement="bottom-end"
            data-kt-menu-trigger="click"
            href="#"
          >
            <KTIcon className="fs-6 text-muted me-1" iconName="filter" />
            Filter
          </a>
          <Dropdown1 />
        </div>
      )}

      {!!config.app?.toolbar?.daterangepickerButton && (
        <div
          className={clsx('btn btn-sm fw-bold  d-flex align-items-center px-4', daterangepickerButtonClass)}
          data-kt-daterangepicker="true"
          data-kt-daterangepicker-opens="left"
        >
          <div className="text-gray-600 fw-bold">Loading date range...</div>
          <KTIcon className="fs-1 ms-2 me-0" iconName="calendar-8" />
        </div>
      )}

      {!!config.app?.toolbar?.secondaryButton && (
        <a className="btn btn-sm btn-flex btn-light fw-bold" href="#">
          Filter
        </a>
      )}

      {!!config.app?.toolbar?.primaryButton && (
        <a className="btn btn-sm fw-bold btn-primary" href="#" onClick={() => setShowCreateAppModal(true)}>
          Create
        </a>
      )}
    </div>
  );
};

export { ToolbarClassic };
